import axios from "axios";
import { Message } from "element-ui";
// create an axios instance
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    baseURL: window.API_Server || location.origin, // url = base url + request url
    //baseURL: location.origin, // url = base url + request url
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 20000 * 10, // request timeout
});

// request interceptor
service.interceptors.request.use(
    (config) => {
        //config.headers['Content-Type'] = 'application/json;charset=utf-8';
        //config.headers["token"] = 'xxxxx';
        return config;
    },
    (error) => {
        console.error(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    async (response) => {
        const res = response.data;
        const responseType = response.config.responseType;
        return res;
    },
    (error) => {
        console.log("err" + error); // for debug
        Message({
            showClose: true,
            message: error.message,
            type: "error",
            duration: 5 * 1000,
        });
        return Promise.reject(error);
    }
);

export default service;
